// Ordering between tours that can be mounted at the same time (page tours
// live inside the sidebar's Layout). A tour listed here won't auto-start
// until the tour it points to has finished or been skipped.
export const TOUR_DEPENDENCIES = {
  cases: "sidebar",
  caseDetails: "sidebar",
  userManagement: "sidebar",
};

// Step content for each onboarding tour, keyed by tourKey.
// `target` must match a `data-tour="..."` attribute placed on the real element.
// Steps whose target isn't present in the DOM when a tour starts are dropped
// automatically by useOnboardingTour — pages don't need to filter conditional
// UI (e.g. the Approve button or Documents tab) in and out themselves.
export const TOUR_STEPS = {
  sidebar: [
    {
      target: '[data-tour="nav-cases"]',
      title: "Cases",
      content: "Every inspection case lands here as it comes in from the AI pipeline.",
      placement: "right",
    },
    {
      target: '[data-tour="nav-people"]',
      title: "Users",
      content: "Manage teammates and their access levels.",
      placement: "right",
    },
    {
      target: '[data-tour="nav-analytics"]',
      title: "Analytics",
      content: "Track review volume and turnaround trends.",
      placement: "right",
    },
  ],

  cases: [
    {
      target: '[data-tour="cases-search"]',
      title: "Find a case fast",
      content: "Search by reference number to jump straight to a case.",
      placement: "bottom",
    },
    {
      target: '[data-tour="cases-status-filter"]',
      title: "Filter by status",
      content: "Narrow the list to AI Assessed, Under Review, or Failed cases.",
      placement: "bottom",
    },
    {
      target: '[data-tour="cases-warning-filter"]',
      title: "Warning flags",
      content: "Cases the AI flagged for review show a warning code here.",
      placement: "bottom",
    },
    {
      target: '[data-tour="cases-date-filter"]',
      title: "Date range",
      content: "Defaults to the current period — widen it to see older cases.",
      placement: "bottom",
    },
    {
      target: '[data-tour="cases-first-row"]',
      title: "Open a case",
      content: "Click any row to see the full AI assessment.",
      placement: "top",
    },
  ],

  caseDetails: [
    {
      target: '[data-tour="case-tab-ai"]',
      title: "AI Summary",
      content: "Vehicle ID, condition, and authenticity checks at a glance.",
      placement: "bottom",
    },
    {
      target: '[data-tour="case-tab-overview"]',
      title: "Overview",
      content: "See damage on the vehicle diagram, plus a breakdown of unidentified parts and sides — tap Parts/Sides Identified to view them.",
      placement: "bottom",
    },
    {
      target: '[data-tour="case-tab-images"]',
      title: "Images",
      content: "Browse the categorized photo set for this case.",
      placement: "bottom",
    },
    {
      target: '[data-tour="case-tab-documents"]',
      title: "Documents",
      content: "Once a case is reviewed, download the full PDF report here.",
      placement: "bottom",
    },
    {
      target: '[data-tour="case-approve-button"]',
      title: "Review & approve",
      content: "When you're satisfied, approve here and add a comment.",
      placement: "left",
    },
  ],

  userManagement: [
    {
      target: '[data-tour="users-add-button"]',
      title: "Add a teammate",
      content: "Invite a reviewer and assign their access level and region.",
      placement: "bottom",
    },
    {
      target: '[data-tour="users-edit-button"]',
      title: "Edit access",
      content: "Change a user's role or access level any time.",
      placement: "left",
    },
  ],
};
